import {apolloClient} from 'shared/apollo'
import insertSessionNotificationSubscriptionMutation from 'shared/graphql/insertSessionNotificationSubscription.gql'
import querySession from 'shared/graphql/querySession.gql'

export default function insertSessionNotificationSubscription({userId, sessionId}) {
	return apolloClient.mutate({
		mutation: insertSessionNotificationSubscriptionMutation,
		variables: {
			userId,
			sessionId,
		},
		update(cache, response) {
			// if response is null, it either did not work, or it was already set (duplicated insert is ignored)
			if (!response.data.insert_session_notification_subscriptions_one) return

			const variables = {id: sessionId, userId, isUserWorkspaceMember: true}
			let data = cache.readQuery({query: querySession, variables})
			if (!data) return

			data = JSON.parse(JSON.stringify(data))
			data.session.notificationSubscriptions.push({userId, __typename: 'session_user_subscription'})

			cache.writeQuery({query: querySession, variables, data})
		},
		optimisticResponse: {
			insert_session_notification_subscriptions_one: {
				__typename: 'session_user_subscription',
				userId,
				sessionId,
			},
		},
	})
}
